<div class="legal-article">

  <h2>{{ title }}</h2>

  <div *ngIf="files.length > 0" class="file-buttons">
    <div *ngFor="let f of files" style="display:flex;align-items:center;gap:8px">
      <button
        class="file-btn"
        (click)="onSelectFile(f)"
        [disabled]="selected?.filename === f.filename"
        [class.selected]="selected?.filename === f.filename"
        [attr.aria-pressed]="selected?.filename === f.filename"
        [attr.aria-label]="'Select ' + f.lang + ' ' + f.version">
        {{ f.lang }} - {{ f.version }}
      </button>
    </div>
  </div>

  <div *ngIf="loading">Loading...</div>
  <div *ngIf="error" style="color:red">{{ error }}</div>

  <div *ngIf="contentSafeHtml" [innerHTML]="contentSafeHtml"></div>
  <div *ngIf="!contentSafeHtml && !loading && !error">No document available.</div>
</div>
